export const ENV_DEV = 'development';
export const ENV_PROD = 'production';
export const CONFIRM_PROGRAM_DEACTIVATION = {
  title: 'Wallet plan deactivated!',
  message:
    'Any ongoing credit or future credit through this plan would stop immediately.',
};
export const genericErrorMsg = 'Oops! Something went wrong.';
export const tryAgainErrorMsg = 'Please refresh the page and try again';
export const wrongFormat = 'Upload a .csv not more than 5 MB';
export const paymentDetailsPendingInfo =
  'Payment details will be updated shortly. Please refresh';
export const paymentDetailsSuccessInfo = 'Payment successful!';
export const paymentDetailsFailedInfo = 'Payment failed';

export const emptyDashboardStateTitle = 'Welcome to Zomato for Enterprise';
export const emptyDashboardStateMessage = 'Get started by adding employees';
export const emptyEmployeesStateTitle = 'Get started by adding employees';
export const emptyProgramStateTitle =
  'Track and manage your meal plan activity here';
export const emptyPaymentsStateTitle =
  'Track all your transactions and payments activity here';
export const emptyReportsStateTitle = 'View your reports here';
export const comingSoonReportsTab = 'Reports are coming soon';

export const MULTI_OFFICES_EMP_ROWS = [
  ['emailId', 'gstin'],
  ['krishna@zomato.com', 'GSTIN123'],
  ['rishabh@zomato.com', 'GSTIN456'],
];

export const billQuestionKey = 'Bill';
